/* import __COLOCATED_TEMPLATE__ from './fin-offer.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency-decorators';
import { taskFor } from 'ember-concurrency-ts';

interface Args {}

export default class FinOffer extends Component<Args> {
  @service declare appService: AppService;
  @service declare customerService: $TSFixMe;
  @service declare router: $TSFixMe;

  get shouldDisplayOffer() {
    let queryParams = this.router.currentRoute.queryParams;
    return queryParams?.finOffer === 'true';
  }

  get refreshOfferStateAndRedirectTask() {
    return taskFor(this.refreshOfferStateAndRedirect);
  }

  @task({ restartable: true })
  *refreshOfferStateAndRedirect() {
    yield this.appService.app.reload();
    yield this.customerService.resetAll();
    yield this.customerService.refreshCustomer();

    this.router.transitionTo(this.router.currentRoute.name, {
      queryParams: {},
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'IncentiveOffer::FinOffer': typeof FinOffer;
    'incentive-offer/fin-offer': typeof FinOffer;
  }
}
